import React from 'react';
import { content, teamMembers } from '../content/team.content.ts';
import Button from './common/Button.tsx';
import { FaLinkedin } from 'react-icons/fa';


const TeamAndAdvisors = () => (
  <section id="team" className="bg-secondary text-primary py-20">
    <div className="container mx-auto px-6">

      <h2 className="text-4xl font-bold text-center text-primary mb-8">{content.name}</h2>


      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {teamMembers
          .filter(member => member.status === 1)
          .map((member, index) => (
            <div key={index} className="bg-primary text-secondary rounded shadow hover:shadow-lg p-6 flex flex-col items-center text-center">

              <img
                src={member.image}
                alt={member.name}
                className="w-64 h-64 rounded-full object-cover mb-6 transform"
              />

              <div className="text-center">
                {/* Name with LinkedIn Icon */}
                <div className="flex items-center justify-center gap-2 mb-2">
                  <h3 className="text-xl font-semibold">{member.name}</h3>
                  <a
                    href={member.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center text-secondary"
                    aria-label={`Visit ${member.name}'s LinkedIn profile`}
                  >
                    <FaLinkedin size={20} />
                  </a>
                </div>
                
                {/* Role */}
                <p className="text-sm text-secondary">{member.role}</p>
              </div>
            </div>
          ))}
      </div>

      {/* Centered Button */}
      <div className="flex justify-center mt-8">
        
        <Button
          to="/team"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="text-lg font-bold hover:bg-primary-100 hover:text-secondary transition"
        >
          Learn More About Us
        </Button>

      </div>

    </div>
  </section>
);

export default TeamAndAdvisors;
